/**============================================================
*   [form] formErrorWP
*   description : フォームのエラー処理（WP用）
============================================================*/
document.addEventListener('DOMContentLoaded', () => {
  const mwForm = document.getElementsByClassName('mw_wp_form_input');

  // header高さ取得
  let header = document.getElementById('header-navigation');
  let headerHeight = (header) ? header.offsetHeight : 0;
  const mqlAnchor = window.matchMedia('(min-width: 768px)');
  function mqlAnchorCheck() {
    headerHeight = (header) ? header.offsetHeight : 0;
  }
  mqlAnchorCheck(mqlAnchor);
  mqlAnchor.addEventListener('change', mqlAnchorCheck, false);

  if (mwForm.length > 0) {
    Array.from(mwForm).forEach((form) => {
      const error = form.getElementsByClassName('error');

      if (error.length > 0) {
        // class調整
        Array.from(error).forEach((errorElement) => {
          const prevError = errorElement.previousElementSibling;
          if (prevError.closest('.c-form-select')) {
            prevError.closest('.c-form-select').classList.add('is-error');
          } else {
            prevError.classList.add('is-error');
          }
        });

        // エラー時スクロール処理
        const errorOffset = error[0].previousElementSibling.closest('.l-gap--form').previousElementSibling.getBoundingClientRect().top + window.pageYOffset;
        const scrollTo = errorOffset - headerHeight - 20;
        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth'
        });
      }
    });
  }
});
